import { render, staticRenderFns } from "./index.vue?vue&type=template&id=765e6d64&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=765e6d64&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "765e6d64",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Volumes/Untitled/project/050/050admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('765e6d64')) {
      api.createRecord('765e6d64', component.options)
    } else {
      api.reload('765e6d64', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=765e6d64&scoped=true", function () {
      api.rerender('765e6d64', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/rate-driver/index.vue"
export default component.exports